import { ReschedulePickupRepository } from "@/app/infrastructures/repositories/api/ReschedulePickupRepository";
import { ReschedulePickupRequestInterface, UpdateReschedulePickupRequestInterface, RejectReschedulePickupRequestInterface } from "@/data/payload/contracts/ReschedulePickupRequest";
import { ReschedulePickupDetail, ReschedulePickupDetailV2, ReschedulePickups, SubDistrict, Village } from "@/domain/entities/ReschedulePickup";
import { Pagination } from "@/domain/entities/Main";
import { injectable } from "tsyringe";

@injectable()
export class ReschedulePickupPresenter {
  private repository: ReschedulePickupRepository

  constructor(repository: ReschedulePickupRepository) {
    this.repository = repository
  }

  public getSubDistrict(params: Map<string, string>): Promise<SubDistrict> {
    return this.repository.getSubDistrict(params)
  }

  public getVillage(params: Map<string, string>): Promise<Village> {
    return this.repository.getVillage(params)
  }

  public getAll(params: Map<string, string | number | Date>): Promise<ReschedulePickups> {
    return this.repository.getAll(params)
  }

  public getAllV2(params: Map<string, string | number | Date>): Promise<ReschedulePickups> {
    return this.repository.getAllV2(params)
  }

  public postRequestApprove(payload: ReschedulePickupRequestInterface): Promise<boolean> {
    return this.repository.postRequestApprove(payload)
  }

  public postRequestReject(payload: RejectReschedulePickupRequestInterface): Promise<boolean> {
    return this.repository.postRequestReject(payload)
  }

  public get(id: string, params: Map<string, string> = new Map<string, string>()): Promise<ReschedulePickupDetail> {
    return this.repository.get(id, params)
  }

  public getDetailV2(payload: { id: string, params: Map<string, string> }): Promise<ReschedulePickupDetailV2> {
    return this.repository.getDetailV2(payload)
  }

  public update(payload: UpdateReschedulePickupRequestInterface): Promise<boolean> {
    return this.repository.update(payload)
  }

  public updateV2(payload: UpdateReschedulePickupRequestInterface){
    return this.repository.updateV2(payload)
  }

  public getCounter(): Promise<number> {
    return this.repository.getCounter();
  }
}
